module.exports = __webpack_public_path__ + "static/media/landing-pattern.f2cad8a5.png";